<ng-container *ngTemplateOutlet="props.customTemplate" />
